import axios from "axios";
import { IP } from "./config";

// 查询会员卡配置
export async function selectVipConfig(data) {
  var resp = await axios.post(`${IP}/vipConfig/selectVipConfig`, {
    ...data,
  });
  return resp.data;
}
// 新增会员卡配置
export async function addVipConfig(form) {
  var resp = await axios.post(`${IP}/vipConfig/addVipConfig`, {
    ...form,
  });
  return resp.data;
}
// 修改会员卡配置
export async function updateVipConfig(form) {
  var resp = await axios.post(`${IP}/vipConfig/updateVipConfig`, {
    ...form,
  });
  return resp.data;
}
// 删除会员卡配置
export async function deleteVipConfig(id) {
  var resp = await axios.post(`${IP}/vipConfig/deleteVipConfig`, {
    id,
  });
  return resp.data;
}
